import RespondToMailOffer from './RespondToMailOffer'

export default RespondToMailOffer
